// src/lib/clarity.js
//
// Microsoft Clarity – session replay, heatmap, felhasználónkénti idővonal.
// Ugyanaz a szabály, mint a gtag-nél: KIZÁRÓLAG süti-elfogadás után töltődik be
// (a CookieBanner hívja a loadClarity()-t), enélkül minden hívás no-op.

// A Clarity projekt azonosítója (Clarity → Settings → Setup, vagy a tracking
// code snippetben a https://www.clarity.ms/tag/<ID> végén álló rövid string).
export const CLARITY_ID = "yjsgyju8x7";

let loaded = false;

export function loadClarity() {
  if (typeof window === "undefined") return;
  if (loaded || !CLARITY_ID) return;
  loaded = true;

  // A Microsoft hivatalos snippetje
  window.clarity =
    window.clarity ||
    function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${CLARITY_ID}`;

  const first = document.getElementsByTagName("script")[0];
  if (first && first.parentNode) {
    first.parentNode.insertBefore(script, first);
  } else {
    document.head.appendChild(script);
  }
}

function ready() {
  return typeof window !== "undefined" && typeof window.clarity === "function";
}

// Egyedi esemény – ezekre lehet szűrni a felvételek között
export function clarityEvent(name) {
  if (!ready()) return;
  try {
    window.clarity("event", name);
  } catch (e) {
    // a Clarity hibája ne vigye el az oldalt
  }
}

// Címke a sessionre (pl. melyik mezőnél akadt el az űrlap)
export function claritySetTag(key, value) {
  if (!ready()) return;
  try {
    window.clarity("set", key, String(value));
  } catch (e) {
    // ne dobjon
  }
}

// A session felvételének priorizált megőrzése (fontos pillanatoknál)
export function clarityUpgrade(reason) {
  if (!ready()) return;
  try {
    window.clarity("upgrade", reason);
  } catch (e) {
    // ne dobjon
  }
}
